"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAccountEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const CheckBox_1 = require("../../../../CheckBox");
const CreateAccountEditor = (props) => {
    const { field } = props;
    if (field.hidden)
        return null;
    return (react_1.default.createElement("div", { className: `${__1.className}__create-account` },
        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/BillingInformation:createAccount', defaultMessage: 'Create account' }), modificators: ['inline'], onChange: field.onEvent, checked: field.value })));
};
exports.CreateAccountEditor = CreateAccountEditor;
//# sourceMappingURL=CreateAccountEditor.js.map